import React, {useEffect, useReducer, createContext} from 'react';
import {Switch, Route} from 'react-router'
import {BrowserRouter} from 'react-router-dom'

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import Room from './pages/Room';
import ScrumBoard from './pages/ScrumBoard';
import Boards from './pages/Boards';
import ForgotPasswordEmailSent from './pages/ForgotPasswordEmailSent';
import ForgotLoginEmailSent from './pages/ForgotLoginEmailSent';
import SignUpEmailSent from './pages/SignUpEmailSent';
import ActivateAccount from './pages/ActivateAccount';
import ResetPassword from './pages/Login/reset-password';
import ConfigPage from './pages/Config';
//teste
import AppContext from './redux/contexts/appContext';
import appReducer from './redux/reducers/appReducer';

function Router() {

  const initialState = {user: {}, theme: "light"};
  const [state, dispatch] = useReducer(appReducer, initialState);



  return (
    <AppContext.Provider value={{state, dispatch}}>
      <BrowserRouter>
        <Routes state={state}></Routes>
      </BrowserRouter>  
    </AppContext.Provider>
  );
}

function Routes({state}) {
  
  if (state?.user?.token) {
    return <AfterLoginRoutes/>;
  }
  else {
    return <PreLoginRoutes/>;
  }
}

function PreLoginRoutes() {
  return (
    <Switch>
      <Route path="/forgot-password-email-sent" component={ForgotPasswordEmailSent}></Route>
      <Route path="/forgot-login-email-sent" component={ForgotLoginEmailSent}></Route>
      <Route path="/reset-password/:forgotPasswordToken" component={ResetPassword}></Route>
      <Route path="/signup-email-sent" component={SignUpEmailSent}></Route>
      <Route path="/activate/:uuid" component={ActivateAccount}></Route>
      <Route component={Login}></Route>
    </Switch>
  )
}

function AfterLoginRoutes() {
  return (
      <Switch>
        <Route exact path="/" component={Home}></Route>
        <Route exact path="/settings" component={ConfigPage}></Route>
        <Route exact path="/room/:roomid" component={Room}></Route>
        <Route exact path="/scrum-board" component={Boards}></Route>
        <Route exact path="/scrum-board/:id" component={ScrumBoard}></Route>
        <Route path="/activate/:uuid" component={ActivateAccount}></Route>
        <Route path="/reset-password/:forgotPasswordToken" component={ResetPassword}></Route>
      </Switch>
  )
}

export default Router;